import React, { useContext } from "react";
import { v4 } from "uuid";
import { Grid, Typography } from "@material-ui/core";
import RecurrentPaymentAction from "../../../../../../../infrastructure/Contexts/components/actions/RecurrentPaymentActionsWrapper/context";
import { ReactComponent as DownloadIcon } from "../../../../../../../assets/icons/download-cloud.svg";
import { RentingFile } from "../../../../../../domain/RecurrentPayment";
import useStyles from "./styles";

export default function RentingFiles({
  rentingFiles,
}: {
  rentingFiles: RentingFile[];
}): JSX.Element {
  const {
    rentingFilesContainer,
    containerInfo,
    stepName,
    iconStyle,
    lineSeparator,
  } = useStyles();

  const { downloadRentingFile } = useContext(RecurrentPaymentAction);

  return (
    <Grid className={rentingFilesContainer}>
      {rentingFiles.map(({ fileId, name, fileName }, index) => (
        <Grid
          key={v4()}
          onClick={() => downloadRentingFile({ fileId, fileName })}
        >
          <Grid container alignItems="center" className={containerInfo}>
            <Typography className={stepName}>{name}</Typography>
            <DownloadIcon className={iconStyle} />
          </Grid>
          {index < rentingFiles.length - 1 && (
            <Grid className={lineSeparator} />
          )}
        </Grid>
      ))}
    </Grid>
  );
}
